import { useOktaAuth } from "@okta/okta-react";
import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { toRelativeUrl } from "@okta/okta-auth-js";
import BaseContainer from "./BaseContainer";
import { setIsUserInAdjacentServiceGroup } from "../lib/amplitude-utils";
import { parseIdTokenPayload } from "../lib/token-utils";

const MainContainer = (): React.JSX.Element => {
  const { oktaAuth, authState } = useOktaAuth();
  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState?.isAuthenticated) {
      const originalUri = toRelativeUrl(
        window.location.href,
        window.location.origin,
      );
      oktaAuth.setOriginalUri(originalUri);
      oktaAuth.signInWithRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oktaAuth, !!authState, authState?.isAuthenticated]);

  if (!authState || !authState?.isAuthenticated) {
    return <></>;
  }

  setIsUserInAdjacentServiceGroup(
    parseIdTokenPayload(authState).isAdjacentServicesUser === true,
  );

  return <BaseContainer childElement={<Outlet />} />;
};

export default MainContainer;
